import { render, staticRenderFns } from "./OverviewSidebar.vue?vue&type=template&id=c2ca920a&scoped=true&"
import script from "./OverviewSidebar.vue?vue&type=script&lang=js&"
export * from "./OverviewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OverviewSidebar.vue?vue&type=style&index=0&id=c2ca920a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ca920a",
  null
  
)

export default component.exports